// File for logic corresponding to header component
import { Component } from 'js-component-framework';
import breakpoints from '@/client/src/js/utils/breakpoints';
import AriaPopup from 'js-component-framework/lib/plugins/AriaPopup';
import '@/client/src/images/alleybot-logo.jpg';

// Styles
import './header.scss';
import './site-navigation.scss';
import './menu.scss';

/**
 * Component for site header
 */
export default class Header extends Component {
  /**
   * Start the component
   */
  constructor(config) {
    super(config);

    // Properties
    this.offset = this.options.offset;
    this.focusableElements = this.getFocusableElements();
    this.bodyEl = document.querySelector('body');
    this.htmlEl = document.querySelector('html');
    this.menuExpanded = false;

    // Methods
    this.bindListeners();
    this.toggleMenu();
    this.menuToggles();

    if (breakpoints.lgMin.matches) {
      this.children.navButton.setAttribute('aria-expanded', 'true');
    }
  }

  getFocusableElements() {
    let focusableElements = [];
    const focusableElementsString = 'a[href], area[href], input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button:not([disabled]), iframe, object, embed, [tabindex="0"], [contenteditable]';

    focusableElements = Array.from(this.children.modal.querySelectorAll(focusableElementsString));

    return focusableElements;
  }

  setMenuOpen() {
    this.bodyEl.style.overflow = 'hidden';
    this.children.navButton.setAttribute('aria-expanded', 'true');
    this.children.modal.classList.add('site-header__navigation--modal');
    this.children.navButton.classList.add('site-header__nav-button--active');

    // Focus first element
    this.focusableElements[0].focus();

    // Set state
    this.menuExpanded = true;
  }

  setMenuClosed() {
    this.bodyEl.style.overflow = 'initial';
    this.children.navButton.setAttribute('aria-expanded', 'false');
    this.children.modal.classList.remove('site-header__navigation--modal');
    this.children.navButton.classList.remove('site-header__nav-button--active');
    this.children.navButton.focus();
    this.menuExpanded = false;
  }

  bindListeners() {
    // const firstTabStop = this.focusableElements[0];
    const firstTabStop = this.children.navButton;
    const lastTabStop = this.focusableElements[this.focusableElements.length - 1];

    this.element.addEventListener('keydown', (e) => {
      this.trapTabKey(e, firstTabStop, lastTabStop);
    });
  }

  trapTabKey(e, firstTabStop, lastTabStop) {
    const expandedCheck = this.children.navButton.getAttribute('aria-expanded');

    // Check if mobile and menu expanded
    if (breakpoints.lgMin.matches || expandedCheck === 'false') {
      return;
    }

    // Chck for tab key
    if (e.keyCode === 9) {
      // Shift + Tab (backward)
      if (e.shiftKey) {
        if (document.activeElement === firstTabStop) {
          e.preventDefault();

          // Send to first tab stop on shift +tab
          lastTabStop.focus();
        }
      } else {
        // Tab (forward)
        if (document.activeElement === lastTabStop) { // eslint-disable-line
          e.preventDefault();

          // Send to toggle bt non last tab stop
          firstTabStop.focus();
        }
      }
    }

    if (e.keyCode === 27) {
      this.setMenuClosed();
    }
  }

  toggleMenu() {
    this.children.navButton.addEventListener('click', () => {
      // Open or close based on state
      if (this.menuExpanded) {
        this.setMenuClosed();
      } else {
        this.setMenuOpen();
      }
    });
  }

  /**
   * Toggle menu dropdowns.
   */
  menuToggles() {
    const { menuToggles } = this.children;

    // return early of no menu items with dropdowns.
    if (!menuToggles.length) {
      return;
    }

    menuToggles.forEach((controller) => {
      const target = controller.parentElement.querySelector('.sub-menu');

      this.subMenu = new AriaPopup({
        controller,
        target,
      });
    });
  }
}
